import {
  Rt
} from "./chunk.LTAMHVKK.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-page-hero/jb-page-hero.scss?inline
var jb_page_hero_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
.with-big-image p, .article-page-hero p, p {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

h1 {
  font-family: var(--theme-font-xlight-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-xlight-weight, 200);
}

h1 {
  font-size: var(--theme-typo-h1-overview-mobile-fontsize, 1.75rem);
  letter-spacing: var(--theme-typo-h1-overview-mobile-letterspacing, 0.094rem);
  line-height: var(--theme-typo-h1-overview-mobile-lineheight, 2.5rem);
}
@media (min-width: 1281px) {
  h1 {
    font-size: var(--theme-typo-h1-overview-desktop-fontsize, 3.125rem);
    letter-spacing: var(--theme-typo-h1-overview-desktop-letterspacing, 0.25rem);
    line-height: var(--theme-typo-h1-overview-desktop-lineheight, 4.375rem);
  }
}

.article-page-hero p, p {
  font-size: var(--theme-typo-p-big-mobile-fontsize, 1.188rem);
  line-height: var(--theme-typo-p-big-mobile-lineheight, 1.75rem);
}
@media (min-width: 1281px) {
  .article-page-hero p, p {
    font-size: var(--theme-typo-p-big-desktop-fontsize, 1.375rem);
    line-height: var(--theme-typo-p-big-desktop-lineheight, 2.125rem);
  }
}

.with-big-image p {
  font-size: var(--theme-typo-p-small-desktop-fontsize, 1rem);
  line-height: var(--theme-typo-p-small-desktop-lineheight, 1.625rem);
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  --_grid-gap: 16px;
  --_grid-template-columns: repeat(12, 1fr);
  --_outer-padding: calc(6.68% - var(--_grid-gap));
  display: grid;
  gap: var(--grid-row-gap, 0) var(--grid-column-gap, var(--_grid-gap));
  grid-template-columns: [full-start] var(--_outer-padding) [main-start] var(--thme-grid-template-columns, var(--_grid-template-columns)) [main-end] var(--_outer-padding) [full-end];
  grid-template-rows: 1fr;
  padding-inline-end: var(--compensate-scrollbar);
}
@media (min-width: 600px) {
  :host {
    --_outer-padding: calc(8.35% - var(--_grid-gap));
  }
}
@media (min-width: 960px) {
  :host {
    --_grid-gap: 40px;
    --_outer-padding: calc(6.955% - var(--_grid-gap) / 2);
  }
}
@media (min-width: 1281px) {
  :host {
    padding-block-start: var(--spacing-s);
  }
}
@media (min-width: 1437px) {
  :host {
    --_outer-padding: calc((100% - 1437px - 40px) / 2);
  }
}

:host {
  color: var(--host-color, #141e55);
}

:host {
  display: grid;
  padding-block-start: 0;
  --_row-gap: var(--spacing-m);
}

section {
  display: grid;
  grid-column: full;
  grid-template-columns: subgrid;
}

img {
  aspect-ratio: 21/9;
  display: grid;
  grid-column: full;
  object-fit: cover;
  order: 0;
  width: 100%;
}

.content-wrapper {
  display: contents;
}

jb-breadcrumbs {
  grid-column: 2/14;
  margin-block-start: var(--_row-gap);
  order: 1;
}

.layer-wrapper {
  display: contents;
}

h1 {
  grid-column: 2/14;
  margin-block-start: var(--_row-gap);
  order: 2;
  text-transform: uppercase;
}

p {
  grid-column: 2/14;
  margin-block-start: var(--_row-gap);
  order: 3;
}

.content-container {
  display: contents;
  order: 3;
}

.link-container {
  column-count: 1;
  column-gap: var(--_grid-gap);
  grid-column: 2/14;
  margin-block-start: calc(var(--spacing-lm) - var(--spacing-s));
  order: 4;
}

jb-listing-item {
  break-inside: avoid;
  padding-block-start: var(--spacing-s);
}

jb-listing-item:last-of-type {
  padding-block-end: 0;
}

.columns-1 {
  column-count: 1;
}

.columns-2 {
  column-count: 1;
}

.columns-3 {
  column-count: 2;
}

hr {
  border-width: 0;
  border-bottom-width: 1px;
  border-color: rgb(var(--theme-color-royal-blue, 20 30 85));
  grid-column: 2/14;
  margin-block-start: var(--spacing-xl);
  order: 5;
  width: 100%;
}

@media (min-width: 600px) {
  p.next-to-columns-1 {
    grid-column: 2/8;
    order: 4;
  }
  .link-container {
    margin-block-start: calc(var(--_row-gap) - var(--spacing-s));
  }
  .columns-1 {
    grid-column: 8/14;
    order: 4;
  }
  .columns-2 {
    column-count: 2;
    grid-column: 2/14;
    order: 4;
  }
}
@media (min-width: 960px) {
  img {
    aspect-ratio: 21/4;
  }
  p.next-to-columns-1 {
    grid-column: 2/8;
  }
  .columns-1 {
    grid-column: 8/14;
  }
  .columns-2 {
    grid-column: 2/14;
    margin-block-start: calc(var(--_grid-gap) - var(--spacing-s));
  }
}
@media (min-width: 1281px) {
  section {
    --_row-gap: var(--spacing-lm);
  }
  jb-breadcrumbs {
    margin-block-start: var(--spacing-m);
  }
  p {
    font-size: var(--theme-typo-h3-desktop-fontsize, 1.625rem);
    line-height: var(--theme-typo-h3-desktop-lineheight, 2.25rem);
  }
  p.next-to-columns-1 {
    grid-column: 2/10;
  }
  .link-container {
    margin-block-start: calc(var(--_row-gap) - var(--spacing-s));
  }
  .columns-1 {
    grid-column: 10/14;
  }
  p.next-to-columns-2 {
    grid-column: 2/7;
  }
  .columns-2 {
    grid-column: 7/14;
  }
}
@media (min-width: 1437px) {
  p {
    grid-column: 2/11;
  }
  p.next-to-columns-2 {
    grid-column: 2/8;
  }
  .columns-2 {
    grid-column: 8/14;
  }
}
.with-image jb-breadcrumbs {
  order: 2;
}
.with-image img {
  order: 1;
}

.with-big-image section {
  row-gap: 0;
}
.with-big-image jb-breadcrumbs {
  grid-column: main;
  margin-block: var(--spacing-m) var(--spacing-s);
  order: 1;
}
.with-big-image img {
  aspect-ratio: 16/9;
  grid-column: full;
  order: 2;
}
.with-big-image .layer-wrapper {
  display: contents;
}
.with-big-image .content-container {
  background-color: rgb(var(--theme-color-royal-blue, 20 30 85));
  color: rgb(var(--theme-color-white, 255 255 255));
  display: block;
  grid-column: full;
  order: 3;
  padding-block: var(--spacing-m);
  padding-inline: 25px;
}
.with-big-image h1,
.with-big-image p {
  margin-block: 0;
  text-align: center;
}
.with-big-image h1 {
  margin-block: 0 var(--spacing-2xs);
}
.with-big-image .link-container {
  margin-block: calc(var(--spacing-m) - var(--spacing-s)) var(--spacing-m);
}
.with-big-image .columns-1 {
  grid-column: 2/14;
}
.with-big-image .columns-2,
.with-big-image .columns-3 {
  column-count: 1;
}
.with-big-image hr {
  display: none;
}
@media (min-width: 960px) {
  .with-big-image img {
    grid-column: main;
  }
  .with-big-image .layer-wrapper {
    display: block;
    grid-column: 3/13;
    order: 2;
    position: relative;
  }
  .with-big-image .content-container {
    bottom: var(--spacing-xl);
    display: block;
    padding: var(--spacing-m);
    position: absolute;
  }
  .with-big-image .columns-1 {
    grid-column: 4/12;
  }
  .with-big-image .columns-2,
  .with-big-image .columns-3 {
    column-count: 2;
  }
}
@media (min-width: 1281px) {
  .with-big-image h1 {
    margin-block-end: var(--spacing-sm);
  }
  .with-big-image p {
    font-size: var(--theme-typo-p-desktop-fontsize, 1.188rem);
    line-height: var(--theme-typo-p-desktop-lineheight, 2.125rem);
  }
  .with-big-image .content-container {
    padding: var(--spacing-xl);
  }
  .with-big-image .columns-2 {
    grid-column: 3/13;
  }
  .with-big-image .columns-3 {
    column-count: 3;
  }
}
@media (min-width: 1437px) {
  .with-big-image .content-container {
    bottom: 80px;
  }
  .with-big-image .columns-2 {
    grid-column: 3/13;
  }
}

.article-page-hero {
  --_content-shift: 0px;
  --_background: rgb(\$color-white);
  margin-block-end: var(--spacing-xl);
}
.article-page-hero img {
  aspect-ratio: 21/9;
  grid-column: full;
  order: 1;
}
.article-page-hero .content-wrapper {
  background: none;
  display: grid;
  grid-column: 1/15;
  grid-template-columns: subgrid;
  margin-block-start: calc(0px - var(--_content-shift));
  order: 2;
  z-index: 20;
}
.article-page-hero hr {
  grid-column: 2/14;
  margin-block-end: 0;
}
@media (min-width: 960px) {
  .article-page-hero {
    --_content-shift: 144px;
  }
  .article-page-hero .content-wrapper {
    background-color: rgb(var(--theme-color-white, 255 255 255));
    grid-column: 2/14;
  }
  .article-page-hero jb-breadcrumbs,
  .article-page-hero h1,
  .article-page-hero p,
  .article-page-hero .link-container,
  .article-page-hero hr {
    grid-column: 2/12;
  }
  .article-page-hero p.next-to-columns-1 {
    grid-column: 2/7;
  }
  .article-page-hero .columns-1 {
    grid-column: 7/12;
  }
  .article-page-hero .columns-2 {
    margin-block-start: calc(var(--_grid-gap) - var(--spacing-s));
  }
}
@media (min-width: 1281px) {
  .article-page-hero {
    --_content-shift: 216px;
    --_row-gap: var(--spacing-m);
  }
  .article-page-hero h1,
  .article-page-hero p {
    margin-block-start: var(--spacing-lm);
  }
  .article-page-hero p {
    font-size: var(--theme-typo-h3-desktop-fontsize, 1.625rem);
    line-height: var(--theme-typo-h3-desktop-lineheight, 2.25rem);
  }
  .article-page-hero p.next-to-columns-1 {
    grid-column: 2/8;
  }
  .article-page-hero .link-container {
    margin-block-start: calc(var(--spacing-lm) - var(--spacing-s));
  }
  .article-page-hero .columns-1 {
    grid-column: 8/12;
  }
  .article-page-hero p.next-to-columns-2 {
    grid-column: 2/5;
  }
  .article-page-hero .columns-2 {
    grid-column: 5/12;
  }
}
@media (min-width: 1437px) {
  .article-page-hero {
    --_content-shift: 248px;
  }
  .article-page-hero p.next-to-columns-2 {
    grid-column: 2/6;
    margin-block-start: var(--_grid-gap);
  }
  .article-page-hero .columns-2 {
    grid-column: 6/12;
    margin-block-start: calc(var(--_grid-gap) - var(--spacing-s));
  }
}`;

// src/components/jb-page-hero/jb-page-hero.ts
var JbPageHero = class extends h {
  constructor() {
    super(...arguments);
    this.type = "simple";
    this._maxLinksTotal = 10;
  }
  update(_changedProperties) {
    if (this.type === "with-big-image" || this.type === "article-page-hero") {
      this._maxLinksTotal = 9;
    }
    if (_changedProperties.has("links") && this.links.length > this._maxLinksTotal) {
      this.links = this.links.slice(0, this._maxLinksTotal);
    }
    super.update(_changedProperties);
  }
  _getColumnCount() {
    if (this.links?.length <= 3 && this.type === "with-big-image") {
      return this.links?.length;
    }
    if (this.links?.length > 3 && this.type === "with-big-image") {
      return 3;
    }
    if (this.links?.length < 4) {
      return 1;
    }
    return 2;
  }
  render() {
    return ke`
      <section
        class="${Rt({
      [this.type]: true
    })}"
      >
        ${this.image ? ke` <img src="${this.image}" /> ` : D}

        <div class="content-wrapper">
          ${this.breadcrumbs ? ke` <jb-breadcrumbs>
                ${this.breadcrumbs?.backlink && ke`<jb-breadcrumbs-back-link
                  .link=${this.breadcrumbs.backlink.link}
                  .text=${this.breadcrumbs.backlink.text}
                  slot="backlink"
                ></jb-breadcrumbs-back-link>`}
                ${this.breadcrumbs.items?.map(
      (breadcrumb) => ke`<jb-breadcrumbs-item
                      .link=${breadcrumb.link}
                      .text=${breadcrumb.text}
                      slot="items"
                    ></jb-breadcrumbs-item>`
    )}
              </jb-breadcrumbs>` : D}
          ${this.type === "with-big-image" ? ke`
                <div class="layer-wrapper">
                  <div class="content-container">
                    <h1>${this.headline}</h1>
                    <p>${this.text}</p>
                  </div>
                </div>
              ` : ke`
                <div class="layer-wrapper">
                  <h1>${this.headline}</h1>
                  <p
                    class="${Rt({
      ["next-to-columns-" + this._getColumnCount()]: this.links?.length > 0
    })}"
                  >
                    ${this.text}
                  </p>
                </div>
              `}
          ${this.links?.length > 0 ? ke`
                <div
                  class="${Rt({
      "link-container": true,
      ["columns-" + this._getColumnCount()]: true
    })}"
                >
                  ${this.links ? this.links.map(
      (item) => ke`
                          <jb-listing-item
                            .link=${item.link}
                            .text=${item.text}
                          ></jb-listing-item>
                        `
    ) : D}
                </div>
              ` : D}

          <hr />
        </div>
      </section>
    `;
  }
};
JbPageHero.styles = r(jb_page_hero_default);
__decorateClass([
  n({ type: Object })
], JbPageHero.prototype, "breadcrumbs", 2);
__decorateClass([
  n()
], JbPageHero.prototype, "headline", 2);
__decorateClass([
  n()
], JbPageHero.prototype, "image", 2);
__decorateClass([
  n({ type: Array })
], JbPageHero.prototype, "links", 2);
__decorateClass([
  n()
], JbPageHero.prototype, "text", 2);
__decorateClass([
  n()
], JbPageHero.prototype, "type", 2);
JbPageHero = __decorateClass([
  customElement("jb-page-hero")
], JbPageHero);

export {
  JbPageHero
};
